export default "__VITE_ASSET__B4zIAC6u__"